import React from "react";
import { useNavigate, useLocation, Routes, Route, Navigate } from "react-router-dom";
import ClientAppSidebar from "../components/ClientAppSidebar";
import ARAgingPage from "./ARAgingPage";
import APAgingPage from "./APAgingPage";
import ProfitAndLossPage from "./ProfitAndLossPage";
import BalanceSheetPage from "./BalanceSheetPage";
import CashFlowStatementPage from "./CashFlowStatementPage";

export default function BooksDashboardPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveTab = (): string => {
    const path = location.pathname;
    if (path.includes("/profit-loss")) return "profit-loss";
    if (path.includes("/balance-sheet")) return "balance-sheet";
    if (path.includes("/cash-flow")) return "cash-flow";
    if (path.includes("/ar-aging")) return "ar-aging";
    if (path.includes("/ap-aging")) return "ap-aging";
    return "profit-loss"; // default
  };

  const activeTab = getActiveTab();

  const handleTabClick = (tab: string) => {
    navigate(`/books/${tab}`);
  };

  return (
    <div className="flex w-full h-screen overflow-hidden">
      <ClientAppSidebar />
      
      <div className="flex grow shrink-0 basis-0 flex-col items-start overflow-hidden bg-default-background">
        {/* Tab Navigation */}
        <div className="flex w-full flex-col items-start border-b border-solid border-neutral-border px-6 py-4">
          <div className="flex w-full items-center gap-6 mt-4">
            <div
              className={`flex items-center gap-2 pb-2 cursor-pointer ${
                activeTab === "profit-loss"
                  ? "border-b-2 border-solid border-brand-600"
                  : ""
              }`}
              onClick={() => handleTabClick("profit-loss")}
            >
              <span
                className={
                  activeTab === "profit-loss"
                    ? "text-body-bold font-body-bold text-brand-600"
                    : "text-body font-body text-subtext-color"
                }
              >
                Profit & Loss
              </span>
            </div>
            <div
              className={`flex items-center gap-2 pb-2 cursor-pointer ${
                activeTab === "balance-sheet"
                  ? "border-b-2 border-solid border-brand-600"
                  : ""
              }`}
              onClick={() => handleTabClick("balance-sheet")}
            >
              <span
                className={
                  activeTab === "balance-sheet"
                    ? "text-body-bold font-body-bold text-brand-600"
                    : "text-body font-body text-subtext-color"
                }
              >
                Balance Sheet
              </span>
            </div>
            <div
              className={`flex items-center gap-2 pb-2 cursor-pointer ${
                activeTab === "cash-flow"
                  ? "border-b-2 border-solid border-brand-600"
                  : ""
              }`}
              onClick={() => handleTabClick("cash-flow")}
            >
              <span
                className={
                  activeTab === "cash-flow"
                    ? "text-body-bold font-body-bold text-brand-600"
                    : "text-body font-body text-subtext-color"
                }
              >
                Cash Flow Statement
              </span>
            </div>
            <div
              className={`flex items-center gap-2 pb-2 cursor-pointer ${
                activeTab === "ar-aging"
                  ? "border-b-2 border-solid border-brand-600"
                  : ""
              }`}
              onClick={() => handleTabClick("ar-aging")}
            >
              <span
                className={
                  activeTab === "ar-aging"
                    ? "text-body-bold font-body-bold text-brand-600"
                    : "text-body font-body text-subtext-color"
                }
              >
                AR Aging
              </span>
            </div>
            <div
              className={`flex items-center gap-2 pb-2 cursor-pointer ${
                activeTab === "ap-aging"
                  ? "border-b-2 border-solid border-brand-600"
                  : ""
              }`}
              onClick={() => handleTabClick("ap-aging")}
            >
              <span
                className={
                  activeTab === "ap-aging"
                    ? "text-body-bold font-body-bold text-brand-600"
                    : "text-body font-body text-subtext-color"
                }
              >
                AP Aging
              </span>
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex w-full grow shrink-0 basis-0 flex-col items-start overflow-hidden">
          <Routes>
            <Route index element={<Navigate to="profit-loss" replace />} />
            <Route path="profit-loss" element={<ProfitAndLossPage />} />
            <Route path="balance-sheet" element={<BalanceSheetPage />} />
            <Route path="cash-flow" element={<CashFlowStatementPage />} />
            <Route path="ar-aging" element={<ARAgingPage />} />
            <Route path="ap-aging" element={<APAgingPage />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
